import api from './api';

export const getBranding = () => api.get('/settings/branding');
export const updateBranding = (data) => api.put('/settings/branding', data);

export const getNumberingSettings = () => api.get('/settings/numbering');
export const updateNumberingSettings = (data) => api.put('/settings/numbering', data);

export const getReportReferences = () => api.get('/settings/report-references');
export const updateReportReferences = (data) => api.put('/settings/report-references', data);

export default { getBranding, updateBranding, getNumberingSettings, updateNumberingSettings, getReportReferences, updateReportReferences };
